let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("44gSr")).then(() => parcelRequire('a7zys'));